__webpack_require__.p = "/wp-content/uploads/create-blitzlese-game/";